/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationPreferenceDeliveryScopeType } from './NotificationPreferenceDeliveryScopeType';
import {
    NotificationPreferenceDeliveryScopeTypeFromJSON,
    NotificationPreferenceDeliveryScopeTypeFromJSONTyped,
    NotificationPreferenceDeliveryScopeTypeToJSON,
    NotificationPreferenceDeliveryScopeTypeToJSONTyped,
} from './NotificationPreferenceDeliveryScopeType';

/**
 * 
 * @export
 * @interface NotificationPreferenceSettingDeliveryScope
 */
export interface NotificationPreferenceSettingDeliveryScope {
    /**
     * 
     */
    scope?: NotificationPreferenceDeliveryScopeType;
    /**
     * 
     */
    enabled?: boolean;
}



/**
 * Check if a given object implements the NotificationPreferenceSettingDeliveryScope interface.
 */
export function instanceOfNotificationPreferenceSettingDeliveryScope(value: object): value is NotificationPreferenceSettingDeliveryScope {
    return true;
}

export function NotificationPreferenceSettingDeliveryScopeFromJSON(json: any): NotificationPreferenceSettingDeliveryScope {
    return NotificationPreferenceSettingDeliveryScopeFromJSONTyped(json, false);
}

export function NotificationPreferenceSettingDeliveryScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceSettingDeliveryScope {
    if (json == null) {
        return json;
    }
    return {
        
        'scope': json['scope'] == null ? undefined : NotificationPreferenceDeliveryScopeTypeFromJSON(json['scope']),
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
    };
}

export function NotificationPreferenceSettingDeliveryScopeToJSON(json: any): NotificationPreferenceSettingDeliveryScope {
    return NotificationPreferenceSettingDeliveryScopeToJSONTyped(json, false);
}

export function NotificationPreferenceSettingDeliveryScopeToJSONTyped(value?: NotificationPreferenceSettingDeliveryScope | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scope': NotificationPreferenceDeliveryScopeTypeToJSON(value['scope']),
        'enabled': value['enabled'],
    };
}

